<button type="button" class="btn-search" (click)="onExportClick()">
        <i class="fas fa-file-excel"></i> Exportar
      </button>

